"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CustomDateRanges;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _DateFormat = require("./DateFormat.types");
var _Icons = require("./Icons");
var _CustomDateRange = require("./CustomDateRange.hooks");
var _DateRangeWrapper = require("./DateRangeWrapper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var defaultMenuItemNames = ['today', 'yesterday', 'this_week', 'last_week', 'this_month', 'last_month', 'custom'];
function CustomDateRanges(_ref) {
  var onChange = _ref.onChange,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    _ref$menuItemsCustom = _ref.menuItemsCustom,
    menuItems = _ref$menuItemsCustom === void 0 ? defaultMenuItemNames : _ref$menuItemsCustom;
  var _useState = (0, _react.useState)(function () {
      return (0, _core.getLocale)();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    locale = _useState2[0];
  var _useState3 = (0, _react.useState)('MMMM D, YYYY'),
    _useState4 = _slicedToArray(_useState3, 1),
    maskDate = _useState4[0];
  var _useDates = (0, _CustomDateRange.useDates)(),
    _useDates2 = _slicedToArray(_useDates, 3),
    dates = _useDates2[0],
    maskStartDate = _useDates2[1],
    maskEndDate = _useDates2[2];
  var today = dates.today,
    yesterday = dates.yesterday,
    thisMonthStart = dates.thisMonthStart,
    thisMonthEnd = dates.thisMonthEnd,
    lastMonthStart = dates.lastMonthStart,
    lastMonthEnd = dates.lastMonthEnd,
    thisWeekStart = dates.thisWeekStart,
    thisWeekEnd = dates.thisWeekEnd,
    lastWeekStart = dates.lastWeekStart,
    lastWeekEnd = dates.lastWeekEnd;
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    selected = _useState6[0],
    setSelected = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    dateRanges = _useState8[0],
    setDateRanges = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    gridAnchorEl = _useState10[0],
    setGridAnchorEl = _useState10[1];
  var _useState11 = (0, _react.useState)({
      startDate: maskStartDate(startDate !== null && startDate !== void 0 ? startDate : new Date()),
      endDate: maskEndDate(endDate !== null && endDate !== void 0 ? endDate : new Date()),
      key: 'selection'
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    selectionRate = _useState12[0],
    setSelectionRate = _useState12[1];
  var setValues = (0, _react.useCallback)(function (start, end) {
    setSelectionRate(function (curr) {
      return Object.assign(Object.assign({}, curr), {
        startDate: start,
        endDate: end
      });
    });
    setDateRanges("".concat((0, _DateFormat.formatDate)({
      date: start,
      pattern: maskDate
    }), " - ").concat((0, _DateFormat.formatDate)({
      date: end,
      pattern: maskDate
    })));
  }, [maskDate]);
  (0, _react.useEffect)(function () {
    setValues(startDate !== null && startDate !== void 0 ? startDate : new Date(), endDate !== null && endDate !== void 0 ? endDate : new Date());
  }, [startDate, endDate, setValues]);
  var onAccept = function onAccept() {
    onChange(maskStartDate(selectionRate.startDate), maskEndDate(selectionRate.endDate));
    onClosePopup();
  };
  var onShowPopup = function onShowPopup(event) {
    setGridAnchorEl(event.currentTarget);
  };
  var onClosePopup = function onClosePopup() {
    setGridAnchorEl(null);
  };
  var onChangeRange = function onChangeRange(ranges) {
    setSelected('custom');
    setValues(ranges.selection.startDate, ranges.selection.endDate);
  };
  var selectRange = function selectRange(selected) {
    setSelected(selected);
    switch (selected) {
      case 'today':
        setValues(today, today);
        break;
      case 'yesterday':
        setValues(yesterday, yesterday);
        break;
      case 'this_week':
        setValues(thisWeekStart, thisWeekEnd);
        break;
      case 'last_week':
        setValues(lastWeekStart, lastWeekEnd);
        break;
      case 'this_month':
        setValues(thisMonthStart, thisMonthEnd);
        break;
      case 'last_month':
        setValues(lastMonthStart, lastMonthEnd);
        break;
      default:
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    color: "info",
    variant: "contained",
    size: "large",
    fullWidth: true,
    endIcon: /*#__PURE__*/_react["default"].createElement(_Icons.ExpandMoreIcon, null),
    onClick: onShowPopup
  }, dateRanges)), gridAnchorEl && (/*#__PURE__*/_react["default"].createElement(_material.Menu, {
    id: "date-range-item",
    anchorEl: gridAnchorEl,
    keepMounted: true,
    onClose: onClosePopup,
    open: true,
    TransitionComponent: _material.Fade
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, menuItems.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: item,
      onClick: function onClick() {
        return selectRange(item);
      },
      selected: item === selected,
      dense: true
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "inherit",
      color: selected === item ? 'primary' : 'inherit'
    }, (0, _core.translate)("date_ranges.".concat(item))));
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 8
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pl: 1,
    pt: 1
  }, /*#__PURE__*/_react["default"].createElement(_DateRangeWrapper.DateRangeWrapper, {
    selectionRate: selectionRate,
    onChangeRange: onChangeRange,
    locale: locale
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    px: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: onAccept,
    variant: "outlined",
    color: "primary"
  }, (0, _core.translate)('buttons.accept'))))))))));
}